import rootService from 'core/services.root';

export default rootService({
    deletePatient: ['DELETE', '/patient/delete/:patient_id'],
    fetchAbsenceReport: ['GET', '/patient/absence-report/:id'],
    fetchAbsenceReportsDownload: ['GET', '/patient/absence-report/listing/details'],
    fetchAbsenceReportsPage: ['GET', '/patient/absence-report/listing/paginated'],
    fetchPatientAudit: ['GET', '/audit/paginated'],
    fetchPatientData: ['GET', '/patient/info/:patient_id'],
    fetchPatientDiagnostic: ['GET', '/diagnostic/:id'],
    fetchPatientHistory: ['GET', '/patient/history'],
    fetchPatientPage: ['GET', '/patient/listing/paginated'],
    fetchPatientPositions: ['GET', '/position/patient/:patient_id'],
    fetchPatientRecap: ['GET', '/call/recap/:id'],
    getPatientList: ['GET', '/patient/listing'],
    postPatient: ['POST', '/patient/store'],
    postPatientExternalLogin: ['POST', '/patient/login-external'],
    postPatientImport: ['POST', '/patient/massive/store'],
    postPatientSocket: ['POST', '/patient/socket-check/:patient_id'],
    putAttachPatient: ['PUT', '/admin/patient/attach/:patient_id'],
    putPatient: ['PUT', '/patient/update'],
    putPatientPositions: ['PUT', '/position/patient/update/:patient_id'],
    registerPatient: ['POST', '/patient/pin/store']
});
